import LoginPage from './login/LoginPage.vue';
import RegistrationPage from './registration/RegistrationPage.vue';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    meta: {
      title: 'Connexion - Dashboard',
      requiresAuth: false
    }
  },
  {
    path: '/register-hidden',
    name: 'register',
    component: RegistrationPage,
    meta: {
      title: 'Inscription',
      requiresAuth: false
    }
  }
];

export default routes;
